import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { MultiCartService } from '@cart/data-access';
import { EffectsModule } from '@ngrx/effects';
import { Config, ConfigInitializerService, PageMetaResolver } from '@spartacus/core';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { firstValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';
import { effects } from './effects';
import { CartInterceptor } from './http-interceptors/cart.interceptor';
import { CustomCartPageMetaResolver } from './resolvers';
import { CustomCartPageLayoutHandler, CustomMultiCartService, MultiCartStatePersistenceService } from './services';

export function customCartStatePersistenceFactory(
  cartStatePersistenceService: MultiCartStatePersistenceService,
  configInit: ConfigInitializerService,
): () => void {
  const result = (): Promise<Config> =>
    firstValueFrom(
      configInit.getStable('cmsComponents').pipe(
        tap(() => {
          cartStatePersistenceService.initSync('cmsComponents');
        }),
      ),
    );

  return result;
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    { provide: MultiCartService, useExisting: CustomMultiCartService },
    provideAppInitializer(() => {
      const initializerFn = customCartStatePersistenceFactory(
        inject(MultiCartStatePersistenceService),
        inject(ConfigInitializerService),
      );

      return initializerFn();
    }),
    {
      provide: PageMetaResolver,
      useExisting: CustomCartPageMetaResolver,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: CartInterceptor,
      multi: true,
    },
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CustomCartPageLayoutHandler,
      multi: true,
    },
  ],
})
export class CartFeatureModule {}
